export const environment = {
  production: true,
  connection: {
    name: 'LH Hippach Softline',
    host: 'https://softline.hippach.lgh.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
